import { useEffect, useState } from 'react';
import { Bar } from '@ant-design/plots';
import { formatarReal } from '../functions/funcoes';
import { iContas } from '../interfaces/iFinanceiro';
import { Typography, Flex } from 'antd';
import { getHeight } from '../functions/funcoes';
import { Contas, Preto } from '../constants/Cores';

const { Text } = Typography;

const CtContaCxBca = () => {
  const [dados, setDados] = useState<iContas[]>([]);
  let TextType: 'success' | 'danger' | undefined = undefined;

  useEffect(() => {
    window.addEventListener('contasDelphi', (event: any) => {
      const dadosRecebidos = event.detail;
      setDados(dadosRecebidos);
    });
  }, []);

  function setScroll() {
    if (dados.length <= 10) {
      return false;
    }
    return { x: {} };
  }

  function getAltura() {
    let AAltura = {
      A1920xL1080: 180,
      A1680xL1050: 180,
      A1600xL900: 149,
      A1440xL900: 149,
      A1400xL1050: 149,
      A1366xL768: 139,
      A1280xL1024: 149,
      A1280xL960: 149,
      A1280xL800: 139,
      A1280xL768: 139,
      A1280xL720: 139,
      A1280xL600: 139,
      A1152xL864: 139,
      A1024xL768: 138,
      A800xL600: 138,
    };

    return getHeight(AAltura);
  }

  let Soma = dados.reduce((total, d) => total + d.valor, 0);
  if (Soma > 0) {
    TextType = 'success';
  } else if (Soma < 0) {
    TextType = 'danger';
  } else {
    TextType = undefined
  };

  const config = {
    data: dados,
    height: getAltura(),
    xField: 'contas',
    axis: {
      x: {
        labelFill: Preto,
        tickLength: 0,
        labelFontWeight: 600,
        tick: false,
      },
      y: false
    },
    autoFit: true,
    autoResize: true,
    label: {
      text: (d: iContas, i: number, data: iContas[]) => (formatarReal(d.valor)),
      position: 'left',
      transform: [
        { type: 'contrastReverse' },
        { type: 'overlapDodgeY' }
      ]
    },
    style: {
      maxWidth: 25,
    },
    scrollbar: setScroll(),
    scale: {
      color: {
        palette: Contas
      }
    },
    yField: 'valor',
    colorField: 'contas',
    legend: false,
    tooltip: false,
  };
  return (
    <>
      <Bar {...config} />
      <Flex justify='center'>
        <Text>Saldo: <Text
          style={{ fontWeight: 700 }}
          type={TextType}>{formatarReal(Soma)}</Text></Text>
      </Flex>
    </>
  )

};

export default CtContaCxBca;